module.exports = __webpack_public_path__ + "static/media/YF85_04.385e3c11.jpg";